import { createUseFetch } from "../helpers/fetchHooks";
import createItemFetcher from "../helpers/item";
export const computeEbroFileUrl = config => {
    const { scenario, program, mode, fileName, options } = config;
    const encodedFileName = encodeURIComponent(fileName);
    const encodedOptions = encodeURIComponent(options);
    return `/api/v1/ebro/${scenario}/${program}/${mode}/?path=${encodedFileName}&options=${encodedOptions}`;
};
const computeItemId = (config) => {
    const { scenario, program, mode, fileName, options } = config;
    return `${scenario}_${program}_${mode}_${fileName}_${options}`;
};
export const ebroFile = createItemFetcher(computeEbroFileUrl, "EBROFILE", computeItemId);
export const createEbroFile = () => ebroFile;
export const useEbroFile = createUseFetch(ebroFile, state => state.ebroFile);
//# sourceMappingURL=index.js.map